import React, { Component } from 'react';
import '../../Style/sidebar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import * as sidebarActions from '../../Store/Actions/sidebarActions';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
import Button from '@material-ui/core/Button';
//Components


class Sidebar extends Component {
    // constructor(props) {
    //   super(props);
    //   // State is in reducers
    // }

    onClickLogout = (e)=>{
      e.preventDefault();
      this.props.logoutReturn();
      this.props.updateActiveMenu("/Login");
      
    }
 
    render() {
      return (
        <div className={this.props.sidebarShow?"Sidebar-wrapper show":"Sidebar-wrapper hide"}>
        <div className="Sidebar">
          <div className="Sidebar-Content">
            {this.props.children}
            <div className="spacer"></div>
            <div className="loginLink-sidebar">
                <div>{this.props.userName}</div>
                <div><Button color="inherit" onClick={this.onClickLogout}>{this.props.isLogged?"Logout":"Login"}</Button></div>
            </div>
          </div>
          
         
        </div>
        <div className="Sidebar-nav" onClick={this.props.toggleSidebar}>
            <FontAwesomeIcon icon={this.props.sidebarShow?"angle-double-left":"angle-double-right"} />
          </div>
        </div>
      );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {   
      sidebarShow : state.appReducer.sidebarShow,
      isLogged : state.apiReducer.isLogged,
      userName : state.apiReducer.username,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      toggleSidebar: (props) => dispatch(sidebarActions.toggleSidebar(props)),
      logoutReturn: () => dispatch(repositoryActions.logoutReturn()),
      updateActiveMenu: (uri) => dispatch(repositoryActions.updateActiveMenu(uri)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
  